module.exports = __webpack_public_path__ + "static/future-dd9c8b52a3d3d45ecf0c3292f5f28f5d.png";